import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getCookies, removeCookie } from "../controllers/cookies.controller";

import mainLogoImg from "../img/main-logo.svg";

import "../styles/header.css";

function Header () {
    const navigate = useNavigate();
    const location = useLocation();
    const token = getCookies('token');
    const isLoggedIn = !!token;

    const isLoginPage = location.pathname === '/login';

    const handleLogout = () => {
        removeCookie('token');
        navigate('/login');
    };

    return (
        <header className="main-header-container">
            <img src={mainLogoImg} className="main-logo" alt="logo image" />
            <div className="header-buttons">
                {isLoggedIn ? (
                    <>
                        <a href="/minha-assinatura">Assinaturas</a>
                        <button onClick={handleLogout} className="logout-button">Sair</button>
                    </>
                ) : (
                    isLoginPage ? (
                        <a href="/">Cadastro</a>
                    ) : (
                        <a href="/login">Login</a>
                    )
                )}
            </div>
        </header>
    )
}

export default Header;